import React from "react";
import Banner_Trending_Project from "../components/body/Trending-Projects/Banner_Trending_Project";
import { Bannerdata } from "./data";
import DevelopersPageComponent from "../components/body/topDevelopersComponents/developerspageComponent/developersPageComponent";
import { developers4S } from "../data/projects/4s/data";
import { developersM3M } from "../data/projects/M3M/data";
import { developersBirla } from "../data/projects/Birla/data";
import { developersConscient } from "../data/projects/Conscient/data";
import { developersDLF } from "../data/projects/DLF/data";
import { developersEldeco } from "../data/projects/eldeco/data";
import { developersMax } from "../data/projects/max/data";
import { developersSignatureGlobal } from "../data/projects/signatureglobal/data";
import { developersSilverGlades } from "../data/projects/silverglades/data";
import { developersSmartworld } from "../data/projects/smartworld/data";
import { developersSobha } from "../data/projects/sobha/data";
import { developersTarc } from "../data/projects/Tarc/data";
import Navbar from "../components/Navbar/Navbar";
import { developersWhiteland } from "../data/projects/whiteland/data";
import { developersShapoorji } from "../data/projects/ShapoorjiPaloonji/data";
import { developersMahindra } from "../data/projects/mahindra/data";
import Main_Footer from "../components/footer/IndiaFooter/Main_Footer";
import { groupProperties } from "../components/body/topDevelopersComponents/filterproperty";
import { allProjectData } from "../data/all_properties/data";
import { Helmet } from "react-helmet";

const Trending_Projects = () => {
  const isState = 1; // Change to 0 if you want to group by location instead of state

  // Group properties based on isState flag
  const groupedProperties = groupProperties(allProjectData, isState);

  return (
    <div>
      <Helmet>
        <title>
          {" "}
          Trending Real Estate Projects in Gurgaon, Pune, Mumbai & Bangalore |
          Property Station
        </title>
        <meta
          name="description"
          content="Explore the latest trending real estate projects in Gurgaon, Pune, Mumbai, and Bangalore with Property Station. Find premium residential & commercial properties with top amenities. Invest in the future today!
"
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://propertystation.in/trending-projects"
        />
      </Helmet>
      <Navbar />
      <Banner_Trending_Project Bannerdata={Bannerdata} />

      {/* Render properties based on grouping condition */}
      <div className="">
        {Object.entries(groupedProperties).length > 0 ? (
          Object.entries(groupedProperties).map(([key, properties]) => (
            <div key={key}>
              {/* Render DevelopersPageComponent with filtered data */}
              <DevelopersPageComponent
                developersData={properties}
                heading={`Properties in ${key}`}
              />
            </div>
          ))
        ) : (
          <p>No properties available.</p> // Fallback message if no properties are found
        )}
      </div>

      <Main_Footer />
    </div>
  );
};

export default Trending_Projects;
